import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-outbound-calls',
  templateUrl: './outbound-calls.component.html',
  styleUrls: ['./outbound-calls.component.scss']
})
export class OutboundCallsComponent implements OnInit {
  @Input() results: any;
  @Input() colors: any;
  @Input() config: any;

  constructor() {}

  ngOnInit() {}
}
